import React, { Component } from 'react'
import { Popover, Modal, Input, Button, Upload, Spin } from 'antd'
import { app, api, config } from '../../../app'
import BrandConfirmation from './UploadInformationModal/BrandConfirmation'
import ApplicationRegistration from './UploadInformationModal/ApplicationRegistration'
import PersonalInformation from './UploadInformationModal/PersonalInformation'
import LetterUndertaking from './UploadInformationModal/LetterUndertaking'
import NoCrimeUndertaking from './UploadInformationModal/NoCrimeUndertaking'
import ProofEducation from './UploadInformationModal/ProofEducation'
import { forEach } from 'underscore'




class UploadInformation extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let Editor = 1
        if (props.Editor != undefined) {
            Editor = 2
        }

        this.state = {
            fileInfo: [],   //初始数据，一进入组件就请求获得
            Editor: Editor,
            volunteerss: [],
            reg_file_json: {
                img: '',
                data: {

                },
            },    //注册申请表信息
            brand_file_json: {
                img: '',
                data: {

                },

            }, //品牌表信息
            personal_file_json: {
                img: '',
                data: {

                },
            },  //个人表信息
            credit_file_json: {
                img: '',
                data: {

                },
            },    //征信承诺书
            criminal_record_json: {
                img: '',
                data: {

                },
            },    //犯罪记录
            education_img: '',   //学历证明图片
            criminal_record_pro_img: '',  //无犯罪记录证明书图片
            // 以上数据都需要转成字符串形式
            spinFlag: true,
            up_loading: true


        }


    }

    componentDidMount() {
        this.getInitialInfo()


    }
    componentWillMount() {

    }

    //获取初始数据
    getInitialInfo = () => {

        const info = app.getData('InitialInfo')
        // console.log(info)
        if (info == undefined) {
            const { fileInfo } = this.state;
            fileInfo.push(...app.getData('examineInfo').file)
            console.log(fileInfo)
            console.log(this.state.fileInfo)
            this.setState({
                spinFlag: false,
                up_loading: false
            })
        } else {

            if (info.teamname == undefined) {
                const { fileInfo } = this.state;
                fileInfo.push(...app.getData('applyinfo').file)
                console.log(fileInfo)
                console.log(this.state.fileInfo)
                this.setState({
                    spinFlag: false,
                    up_loading: false
                })


            } else {
                if (this.props.apply == 1) {
                    const { fileInfo } = this.state;
                    fileInfo.push(...app.getData('applyinfo').file)
                    this.setState({
                        spinFlag: false,
                        up_loading: false
                    })
                    return
                }
                if (this.props.examine == 1) {
                    const { fileInfo } = this.state;
                    fileInfo.push(...app.getData('examineInfo').file)
                    console.log(fileInfo)
                    console.log(this.state.fileInfo)
                    this.setState({
                        spinFlag: false,
                        up_loading: false
                    })
                    return
                }
                const param = {
                    city_id: info.city_id[1],
                    teamname: info.teamname,
                    mobile: info.mobile,
                    name: info.name,
                    idno: info.idno,
                    sms: info.sms,
                }
                app.post(api.TeamGetInit, param).then(res => {
                    if (res.flag == 1) {
                        // 获取初始数据成功
                        //请求数据成功将数据放入到当前组件或副组件
                        // 0为当前组件，属于系统人员数据
                        // console.log(res)
                        const { volunteerss } = this.state;
                        volunteerss.volunteer = res.data.volunteer
                        volunteerss.volunteer_type = res.data.volunteer_type
                        this.setState({
                            fileInfo: res.data.file
                        }, () => {
                            console.log(this.state.fileInfo)
                            this.setState({
                                spinFlag: false,
                                up_loading: false
                            })
                        })
                    } else {
                        // 获取初始数据失败，验证码失效
                        // app.alert('验证码已失效，请重新输入', 'error', '45%')
                        if (this.props.setPage != undefined) {
                            this.props.setPage(2);

                        }
                    }
                })
            }
        }



    }
    // 1
    reg_file_json = (info, infoName) => {
        // console.log(info)
        const { reg_file_json } = this.state
        if (infoName == 'data') {
            reg_file_json.data = info

        } else if (infoName == 'img') {
            reg_file_json.img = info.join(';;;')
        }

        // console.log(reg_file_json)
        this.setState({
            reg_file_json
        })

    }


    // 2
    brand_file_json = (info, infoName) => {
        const { brand_file_json } = this.state
        if (infoName == 'data') {
            brand_file_json.data = info
        } else if (infoName == 'img') {
            brand_file_json.img = info.join(';;;')
            // console.log(brand_file_json)
        }
        // console.log(brand_file_json)
        this.setState({
            brand_file_json
        })
    }

    // 3
    personal_file_json = (info, infoName) => {

        const { personal_file_json } = this.state
        if (infoName == 'data') {
            personal_file_json.data = info
        } else if (infoName == 'img') {
            personal_file_json.img = info.join(';;;')

        }
        // console.log(personal_file_json)

        this.setState({
            personal_file_json
        })
    }
    // 4
    credit_file_json = (info, infoName) => {
        const { credit_file_json } = this.state
        if (infoName == 'data') {
            credit_file_json.data = info
        } else if (infoName == 'img') {
            credit_file_json.img = info.join(';;;')
        }
        // console.log(credit_file_json)

        this.setState({
            credit_file_json
        })
    }
    // 5
    criminal_record_json = (info, infoName) => {
        const { criminal_record_json } = this.state
        let criminal_record_pro_img = this.state.criminal_record_pro_img
        if (infoName == 'zhengmingshu') {
            criminal_record_pro_img = info.join(';;;')
            // 如果用户选择上传证明书，那么将文字内容清空
            criminal_record_json.data.d1 = ''
            criminal_record_json.data.d2 = ''
            criminal_record_json.data.d3 = ''
            criminal_record_json.data.d4 = ''
            criminal_record_json.data.d5 = ''
            criminal_record_json.data.d6 = ''
            criminal_record_json.data.d7 = ''
            criminal_record_json.data.d8 = ''
            criminal_record_json.data.d9 = ''



        } else if (infoName == 'img') {
            criminal_record_json.img = info.join(';;;')

        } else if (infoName == 'data') {
            // console.log(info)
            criminal_record_json.data = info

        }
        // console.log(criminal_record_json)
        this.setState({
            criminal_record_json,
            criminal_record_pro_img
        })
    }

    // 6
    education_img = (info) => {
        // console.log(info.join(';;;'))
        this.setState({
            education_img: info.join(';;;')
        })
    }

    setStorage = async () => {
        const { reg_file_json, brand_file_json, personal_file_json, credit_file_json, criminal_record_json, education_img, criminal_record_pro_img } = this.state;



        const info = app.getData('InitialInfo')
        // console.log(criminal_record_json)
        let crim = JSON.stringify(criminal_record_json)
        // console.log(crim)

        // 系统队员无法添加，有参数错误,非体统人员可以
        const param = {
            area_id: info.city_id[0],
            city_id: info.city_id[1],
            teamname: info.teamname,
            name: info.name,
            idno: info.idno,
            mobile: info.mobile,
            sex: info.sex,
            reg_file_json: JSON.stringify(reg_file_json),
            brand_file_json: JSON.stringify(brand_file_json),
            personal_file_json: JSON.stringify(personal_file_json),
            credit_file_json: JSON.stringify(credit_file_json),
            criminal_record_json: crim,
            education_img: education_img,
            criminal_record_pro_img: criminal_record_pro_img

        }


        app.post(api.TeamSetCacheFile, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })


    }

    setString = async (info) => {
        // let aa0 = info.replace('"0":');
        // let aa1 = aa0.replace('"1":');
        // let aa2 = aa1.replace(",", ";;;")
        // let aa3 = aa2.replace(/undefined/g, "")
        // let aa4 = aa3.replace(":{", ":")
        // let aa5 = aa4.replace("}", "")
        // let aa6 = aa5.replace("}", "")
        // let aa7 = aa6.substring(0,aa6.length-1)
        // return aa5
    }

    updateInfo = async () => {
        // const { reg_file_json, brand_file_json, personal_file_json, credit_file_json, criminal_record_json, education_img, criminal_record_pro_img } = this.state;
        const reg_file_json = this.state.reg_file_json;
        const brand_file_json = this.state.brand_file_json;
        const personal_file_json = this.state.personal_file_json;
        const credit_file_json = this.state.credit_file_json;
        const criminal_record_json = this.state.criminal_record_json;
        const education_img = this.state.education_img;
        const criminal_record_pro_img = this.state.criminal_record_pro_img;

        if (reg_file_json.img == "") {
            app.alert('《存心救援队注册申请表》图片未上传', 'error', '45%')
            return
        }

        if (brand_file_json.img == "") {
            app.alert('《品牌确认书(筹)》图片未上传', 'error', '45%')
            return
        }

        if (personal_file_json.img == "") {
            app.alert('《个人信息表》图片未上传', 'error', '45%')
            return
        }


        let personal = personal_file_json
        let family = []
        personal.data.family.forEach((i, v) => {
            if (i.relation == '' || i.name == '' || i.work_unit == '' || i.mobile == '') {

            } else {
                family.push(personal.data.family[v])
            }

        })
        personal.data.family = family

        let work_exper = []
        personal.data.work_exper.forEach((i, v) => {
            if (i.name == '' || i.nature == '' || i.position == '' || i.join_time == '') {

            } else {
                work_exper.push(personal.data.work_exper[v])
            }

        })
        personal.data.work_exper = work_exper



        let prize = []
        personal.data.prize.forEach((i, v) => {
            if (i.unit == '' || i.name == '' || i.year == '') {

            } else {
                prize.push(personal.data.prize[v])
            }

        })
        personal.data.prize = prize


        if (credit_file_json.img == "") {
            app.alert('《征信承诺书》图片未上传', 'error', '45%')
            return
        }

        if (criminal_record_json.img == "" && criminal_record_pro_img == "" && criminal_record_json.data.d1 == '') {
            app.alert('《无犯罪记录证明书》或《无犯罪记录承诺书》图片未上传', 'error', '45%')
            return
        }

        if (criminal_record_json.data.d1 != '' && criminal_record_json.img == "") {
            app.alert('《无犯罪记录承诺书》图片未上传', 'error', '45%')
            return

        }



        if (education_img == "") {
            app.alert('《学历证明》图片未上传', 'error', '45%')
            return

        }
        const { volunteerss } = this.state;
        let array = []


        if (volunteerss.volunteer_type == 0) {

            volunteerss.volunteer.forEach(item => {
                // console.log(item)

                let volunteer_json = {

                }
                volunteer_json.indexno = item.indexno
                volunteer_json.join_type = item.join_type
                volunteer_json.teamposition_id = item.teamposition_id
                volunteer_json.original_teamno = item.original_teamno
                array.push(volunteer_json)
            })
        } else {
            volunteerss.volunteer.forEach(item => {
                let volunteer_json = {

                }
                volunteer_json.name = item.name
                volunteer_json.mobile = item.mobile
                volunteer_json.idno = item.idno
                volunteer_json.sex = item.sex
                volunteer_json.teamposition_id = item.teamposition_id
                array.push(volunteer_json)
            })

        }

        // console.log(array)
        const info = app.getData('InitialInfo')

        // 系统队员无法添加，有参数错误,非体统人员可以
        const param = {
            area_id: info.city_id[0],
            city_id: info.city_id[1],
            teamname: info.teamname,
            name: info.name,
            idno: info.idno,
            mobile: info.mobile,
            sex: info.sex,
            volunteer_type: volunteerss.volunteer_type,
            volunteer_json: JSON.stringify(array),
            reg_file_json: JSON.stringify(reg_file_json),
            brand_file_json: JSON.stringify(brand_file_json),
            // brand_file_json:   JSON.stringify(brand_file_json),


            personal_file_json: JSON.stringify(personal),
            credit_file_json: JSON.stringify(credit_file_json),
            criminal_record_json: JSON.stringify(criminal_record_json),
            education_img: education_img,
            criminal_record_pro_img: criminal_record_pro_img

        }
        // console.log(param)


        app.post(api.TeamAdd, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')
                this.props.setPage(5)
            } else {
                let familyInfo = {
                    "relation": "",
                    "name": "",
                    "work_unit": "",
                    "mobile": ""
                }
                let work_experInfo = {
                    "name": "",
                    "nature": "",
                    "position": "",
                    "join_time": ""
                }
                let prizeInfo = {
                    "unit": "",
                    "name": "",
                    "year": ""
                }



                // console.log(data.prize.length)

                for (let i = 0; i <= 3 - personal_file_json.data.family.length; i++) {
                    personal_file_json.data.family.push(familyInfo)
                }
                for (let i = 0; i <= 5 - personal_file_json.data.work_exper.length; i++) {
                    personal_file_json.data.work_exper.push(work_experInfo)
                }
                for (let i = 0; i = 6 - personal_file_json.data.prize.length; i++) {
                    personal_file_json.data.prize.push(prizeInfo)
                }
                app.alert(res.msg, 'error', '45%')
            }
        })
    }


    tijiao = () => {
        // console.log(this.state)
        let reg_file_json = this.state.reg_file_json;
        let brand_file_json = this.state.brand_file_json;
        let personal_file_json = this.state.personal_file_json;
        let credit_file_json = this.state.credit_file_json;
        let criminal_record_json = this.state.criminal_record_json;
        let education_img = this.state.education_img;
        let criminal_record_pro_img = this.state.criminal_record_pro_img;
        // console.log(criminal_record_json)

        if (reg_file_json.img == "") {
            app.alert('《存心救援队注册申请表》图片未上传', 'error', '45%')
            return
        }

        if (brand_file_json.img == "") {
            app.alert('《品牌确认书(筹)》图片未上传', 'error', '45%')
            return
        }

        if (personal_file_json.img == "") {
            app.alert('《个人信息表》图片未上传', 'error', '45%')
            return
        }

        if (credit_file_json.img == "") {
            app.alert('《征信承诺书》图片未上传', 'error', '45%')
            return
        }

        if (criminal_record_json.img == "" && criminal_record_pro_img == "" && criminal_record_json.data.d1 == '') {
            app.alert('《无犯罪记录证明书》或《无犯罪记录承诺书》图片未上传', 'error', '45%')
            return
        }

        if (criminal_record_json.data.d1 != '' && criminal_record_json.img == "") {
            app.alert('《无犯罪记录承诺书》图片未上传', 'error', '45%')
            return

        }





        if (education_img == "") {
            app.alert('《学历证明》图片未上传', 'error', '45%')
            return

        }

        for (let i in info) {
            if (i == '') {
                app.alert('缺少数据', 'error', '45%')
                return
            }
        }

        // console.log(personal_file_json)

        let info = {
            reg_file_json: reg_file_json,
            brand_file_json: brand_file_json,
            // brand_file_json:   brand_file_json,


            personal_file_json: personal_file_json,
            credit_file_json: credit_file_json,
            criminal_record_json: criminal_record_json,
            education_img: education_img,
            criminal_record_pro_img: criminal_record_pro_img
        }

        this.props.compon3(info)
        this.props.application()
        // console.log(this.state)

    }

    uploadImgLoading = (flag) => {
        this.setState({
            up_loading: flag
        })
    }

    // 页面渲染区
    render() {
        // console.log(this.props)
        let { fileInfo, spinFlag, up_loading } = this.state
        // console.log(fileInfo)
        return (
            <Spin spinning={up_loading} tip={spinFlag ? '' : '图片上传中'}>
                <div >
                    <div style={{ marginTop: 20 }}>
                        {/* 组件标题 */}
                        <p style={{ fontSize: 16 }} >填写并上传申请资料</p>
                        {/* 组件标题end */}

                    </div>

                    {/* 资料上传 */}
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                            {/* 存心救援队注册申请表 */}
                            {fileInfo.length < 1 ? ''
                                :
                                <ApplicationRegistration
                                    examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}
                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}
                                    detailF={this.props.detailF}
                                    fileInfo={this.state.fileInfo}
                                    com3={this.props.com3 != undefined ? this.props.com3[0] : ''}
                                    reg_file_json={this.reg_file_json}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 存心救援队注册申请表end */}


                            {/* 品牌确认数(筹) */}
                            {fileInfo.length < 1 ? '' :
                                <BrandConfirmation
                                    examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}
                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}
                                    detailF={this.props.detailF}
                                    fileInfo={fileInfo} brand_file_json={this.brand_file_json} com3={this.props.com3 != undefined ? this.props.com3[1] : ''}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 品牌确认数(筹)end */}


                            {/* 个人信息表 */}
                            {fileInfo.length < 1 ? '' :
                                <PersonalInformation examine={this.props.examine}
                                    examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}

                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}

                                    detailF={this.props.detailF}
                                    fileInfo={fileInfo}
                                    personal_file_json={this.personal_file_json}
                                    com3={this.props.com3 != undefined ? this.props.com3[2] : ''}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 个人信息表end */}

                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 100 }}>
                            {/* 征信承诺书 */}
                            {fileInfo.length < 1 ? '' :
                                <LetterUndertaking
                                    examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}
                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}
                                    detailF={this.props.detailF}
                                    fileInfo={fileInfo} credit_file_json={this.credit_file_json} com3={this.props.com3 != undefined ? this.props.com3[3] : ''}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 征信承诺书end */}

                            {/* 无犯罪记录承诺书 */}
                            {fileInfo.length < 1 ? '' :
                                <NoCrimeUndertaking examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}
                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}
                                    detailF={this.props.detailF}
                                    fileInfo={fileInfo}
                                    criminal_record_json={this.criminal_record_json}
                                    com4={this.props.com3 != undefined ? this.props.com3[4] : ''}
                                    com5={this.props.com3 != undefined ? this.props.com3[5] : ''}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 无犯罪记录承诺书end */}

                            {/* 学历证明 */}
                            {fileInfo.length < 1 ? '' :
                                <ProofEducation examine={this.props.examine}
                                    examineInfo={this.props.examineInfo}
                                    apply={this.props.apply}   //申请详情
                                    applyinfo={this.props.applyinfo}
                                    detailF={this.props.detailF}
                                    fileInfo={fileInfo} education_img={this.education_img} com3={this.props.com3 != undefined ? this.props.com3[6] : ''}
                                    uploadImgLoading={this.uploadImgLoading}
                                />
                            }
                            {/* 学历证明end */}
                        </div>
                    </div>
                    {/* 资料上传end */}



                    {/* 功能按钮 */}
                    <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} hidden={this.state.Editor == 2}>
                        <Button style={{ width: 300, marginRight: 50 }} onClick={() => this.props.setPage(3)}>上一步</Button>
                        {/* onClick={this.golast} */}
                        <Button style={{ width: 300, }} onClick={this.setStorage}>暂存</Button>
                        {/* onClick={this.setNowAllData} */}
                        <Button style={{ width: 300, marginLeft: 50, backgroundColor: '#1890FF', color: '#fff' }} onClick={this.updateInfo}>提交</Button>
                        {/* onClick={this.goNext} */}

                    </div>
                    {/* 功能按钮end */}

                    <p hidden={this.state.Editor == 2} style={{ marginTop: 30, color: '#fb7a39', textAlign: 'center' }}>操作流程：1.在线填写信息 2.下载已填写完成的信息表 3.打印信息表并签字加盖手指印 4.拍照上传已签字信息表 5.提交 6.等待审批</p>


                    <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} >
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : this.state.Editor == 2 ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff', }} onClick={this.tijiao}>提交申请资料</Button> : ''
                        }
                    </div>

                </div>

            </Spin>



        )
    }
}



export default UploadInformation



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/UploadInformation.jsx